// src/features/conversationSlice.ts
import { createSlice } from '@reduxjs/toolkit';
import { organizationsApi } from '~/api/organizations-api';
// Define the Conversation type
interface User {
  id?: string;
}

// Define the initial state
interface OrganizationUsersState {
  users: User[] | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: OrganizationUsersState = {
  users: null,
  status: 'idle',
  error: null,
};

// Create the slice
const organizationUsersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch list of organizations
      .addMatcher(organizationsApi.endpoints.getOrganizationUsers.matchPending, (state) => {
        state.status = 'loading';
      })
      .addMatcher(organizationsApi.endpoints.getOrganizationUsers.matchFulfilled, (state, action) => {
        state.status = 'succeeded';
        state.users = action.payload;
      })
      .addMatcher(organizationsApi.endpoints.getOrganizationUsers.matchRejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? 'Failed to fetch organizations';
      });
  },
});

// Export the reducer
export default organizationUsersSlice.reducer;
